module.exports = __webpack_public_path__ + "img/evaluate_thumbnail_000.02faf3d7.jpg";